export default "/images/JAMA.png?3a74f6aa4f5fe46cff00a00342a13e34";